const createBrowserHistory = require("history").createBrowserHistory;

let history = null;

export const getHistory = () => {
  if (!history) {
    history = createBrowserHistory();
  }

  return history;
};



// WEBPACK FOOTER //
// ./src/router/getHistory.js